<template>
<v-container fluid>
  <!-- メインコンテンツ -->
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <!-- 作業日報タイトル -->
        <v-card-title>作業日報</v-card-title>
        <!-- 作業日 -->
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="2">
              <v-text-field label="作業日" v-model="constructionDateSlash" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
            </v-col>
          </v-row>
          <v-row v-if="!prmConstructionKey" no-gutters>
            <v-col cols="12" md="2">
              <v-btn depressed color="success" @click="showConstructionNumberCreateDialog()" :disabled="constructionDateValid">作業報告作成</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 一覧部 -->
        <custom-data-table class="mb-3" :header="reportHeaders" :items="reportItems" :loading="loading">
          <template v-slot:action_worker_content="{ item }">
            <v-btn class="my-2" depressed small color="info" @click.stop="showWorkerContentReferenceDialog(item.tabIndex)">作業内容参照</v-btn>
          </template>
          <template v-slot:action="{ item }">
            <v-btn class="my-2 d-flex" depressed small color="primary" :to="{ name: 'WorkerDailyReportBusinessTripEdit', params: { id: item.id, worker_date: constructionDateSlash, user_id: prmUserId, referrer: 'edit', construction_key: prmConstructionKey } }">出張等</v-btn>
            <v-btn class="my-2 d-flex" depressed small color="primary" :to="{ name: 'WorkerDailyReportExpenseEdit', params: { id: item.id, worker_date: constructionDateSlash, user_id: prmUserId, referrer: 'edit', construction_key: prmConstructionKey } }" :disabled="item.construction_type_name == null">経費等</v-btn>
          </template>
          <template v-slot:action_sub="{ item }">
            <v-btn class="my-2 d-flex" depressed small color="primary" @click.stop="showWorkReportInputDialog(item.id, item.tabIndex)">作業報告編集</v-btn>
            <v-btn class="my-2 d-flex" depressed small color="error" @click.stop="showWorkReportDeleteDialog(item.id, item.tabIndex)">作業報告削除</v-btn>
          </template>
        </custom-data-table>
        <!-- アクション -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" :to="this.returnView">戻る</v-btn>
          <v-btn v-if="!prmConstructionKey" depressed color="primary" @click.prevent="showConfirmationDialog()" :disabled="tabLength == 0">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

  <!-- 工番作成ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="constructionNumberCreateDialogDrawer" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">工番作成</v-card-title>
        <v-card-text>
          <v-form ref="construction_number_create_form" v-model="constructionNumberCreateDialogValid" @submit.prevent>
            <v-select label="部署" prepend-inner-icon="mdi-office-building" :items="departmentItems" item-text="name" item-value="value"
            v-model="department" @change="changeDepartment" :rules="departmentRules" no-data-text="データがありません" dense outlined return-object>
              <template v-slot:append>
                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
              </template>
            </v-select>
            <v-select v-model="constructionNumber" label="工番" prepend-inner-icon="mdi-script-outline" :rules="constructionNumberTagRules"
            :items="constructionNumberList" item-text="text" item-value="name" no-data-text="データがありません" dense outlined return-object :disabled="department == null">
              <template v-slot:append>
                <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
              </template>
            </v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="hideConstructionNumberCreateDialog()">キャンセル</v-btn>
          <v-btn depressed color="success" @click.stop="createConstructionNumberCreateDialog()" :disabled="!constructionNumberCreateDialogValid">作成</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業報告編集ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="workReportInputDialogDrawer" persistent max-width="1200">
      <v-card>
        <v-card-title class="headline">作業報告編集</v-card-title>
        <v-card-text>
          <v-form ref="worker_report_input_form" v-model="workReportInputDialogValid" @submit.prevent>
            <!-- 工事情報 -->
            <v-toolbar color="accent" dark flat dense><v-toolbar-title>工事情報</v-toolbar-title></v-toolbar>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field label="工事名" v-model="inputData.constructionName" prepend-inner-icon="mdi-message-settings-variant-outline" dense outlined readonly/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field label="現場名" v-model="inputData.siteName" prepend-inner-icon="mdi-crane" dense outlined readonly/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-select label="工種" v-model="inputData.constructionType" prepend-inner-icon="mdi-format-list-bulleted-triangle" @change="changeConstructionType"
                :items="inputData.constructionTypeList" item-text="name" item-value="value" :rules="constructionTypeRules" no-data-text="データがありません" dense outlined return-object>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" md="4">
                <v-checkbox class="mb-5" label="作業項目なし" v-model="inputData.workArea" @change="workAreaChange" hide-details></v-checkbox>
              </v-col>
            </v-row>
            <!-- 作業報告 -->
            <v-toolbar color="accent" dark flat dense><v-toolbar-title>作業報告</v-toolbar-title></v-toolbar>
            <div v-if="!workAreaDivision">
              <v-row><v-col cols="12"><header>作業項目(労務費)</header></v-col></v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select label="作業項目(労務費)" v-model="inputData.workItem" prepend-inner-icon="mdi-format-list-bulleted-triangle"
                  :items="inputData.workItemList" item-text="name" item-value="value" :rules="workItemRules" :disabled="inputData.constructionType == null" no-data-text="データがありません" dense outlined return-object>
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row><v-col cols="12"><header>作業時間</header></v-col></v-row>
              <v-row>
                <v-col cols="12" lg="2" md="3">
                  <v-btn depressed color="success" @click.stop="workerTimeInput">作業時間入力</v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="inputData.startWorkerTime" label="作業開始時間" :rules="workerTimeStartRules" prepend-inner-icon="mdi-calendar-clock" dense solo readonly>
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="inputData.endWorkerTime" label="作業終了時間" :rules="workerTimeEndRules" prepend-inner-icon="mdi-calendar-clock" dense solo readonly>
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row><v-col cols="12"><header>残業時間</header></v-col></v-row>
              <v-row>
                <v-col cols="12" lg="2" md="3">
                  <v-btn depressed color="success" @click.stop="overTimeDialogInput">残業時間入力</v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="inputData.startOverTime" label="残業開始時間" prepend-inner-icon="mdi-calendar-clock" dense solo readonly/>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field v-model="inputData.endOverTime" label="残業終了時間" prepend-inner-icon="mdi-calendar-clock" dense solo readonly/>
                </v-col>
              </v-row>
            </div>
            <v-row><v-col cols="12"><header>作業内容</header></v-col></v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea v-model="inputData.workerContent" label="作業内容" rows="5" :rules="workerContentRules" prepend-inner-icon="mdi-comment-text-multiple-outline" counter="1000" outlined>
                  <template v-slot:append>
                    <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="cancelWorkReport()">キャンセル</v-btn>
          <v-btn depressed color="primary" @click.stop="confirmInputDialogDrawer = true" :disabled="!workReportInputDialogValid">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業報告削除ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="workReportDeleteDialogDrawer" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">作業報告削除</v-card-title>
        <v-card-text v-if="tabLength > 0">
          <h4>工番「{{ this.tabDataList[this.selectTab].tabName }} 」の作業報告を削除しますか？</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="workReportDeleteDialogDrawer = false">キャンセル</v-btn>
          <v-btn depressed color="error" @click.stop="deleteWorkReport()">削除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業内容参照ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="workerContentReferenceDialogDrawer" persistent max-width="700">
      <v-card>
        <v-card-title class="headline">作業内容参照</v-card-title>
        <v-card-text v-if="tabLength > 0">
          <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ this.tabDataList[this.selectTab].tabName }}</v-toolbar-title></v-toolbar>
          <v-row>
            <v-col cols="2"><header>工事名</header></v-col>
            <v-col cols="10"><header>{{ this.tabDataList[this.selectTab].constructionName }}</header></v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="2"><header>作業内容</header></v-col>
            <v-col cols="10"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ this.tabDataList[this.selectTab].workerContent }}</header></v-col>
          </v-row>
          <v-divider/>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" @click.stop="workerContentReferenceDialogDrawer = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業時間入力ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="workerTimeDialogDrawer" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">作業時間入力</v-card-title>
        <v-card-text>
          <v-form ref="worker_time_form" v-model="breakTimeValid" @submit.prevent>
            <v-row>
              <v-menu ref="startWorkerMenu" v-model="startWorkerTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="startWorkerTime"
              transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="startWorkerTime" label="作業開始時間" dense outlined readonly v-on="on"/>
                </template>
                <v-time-picker v-if="startWorkerTimeMenu" v-model="startWorkerTime" format="24hr" :max="endWorkerTime" full-width @click:minute="$refs.startWorkerMenu.save(startWorkerTime)"/>
              </v-menu>
            </v-row>
            <v-row>
              <v-menu ref="endWorkerMenu" v-model="endWorkerTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="endWorkerTime"
              transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="endWorkerTime" label="作業終了時間" dense outlined readonly v-on="on"/>
                </template>
                <v-time-picker v-if="endWorkerTimeMenu" v-model="endWorkerTime" format="24hr" :min="startWorkerTime" full-width @click:minute="$refs.endWorkerMenu.save(endWorkerTime)"/>
              </v-menu>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field label="休憩(時間)" v-model="breakHourTime" :rules="breakHourTimeRules" suffix="時間" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="休憩(分)" v-model="breakMinuteTime" :rules="breakMinuteTimeRules" suffix="分" dense outlined/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="workerTimeDialogDrawer = false">キャンセル</v-btn>
            <v-btn depressed color="success" @click.stop="workerTimeDialogHandler()" :disabled="!breakTimeValid">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 残業入力ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="overTimeDialogDrawer" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">残業時間入力</v-card-title>
        <v-card-text>
          <v-form ref="over_time_form" v-model="breakTimeValid" @submit.prevent>
            <v-row>
              <v-menu ref="startOverMenu" v-model="startOverTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="startOverTime"
              transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="startOverTime" label="残業開始時間" dense outlined readonly v-on="on"/>
                </template>
                <v-time-picker v-if="startOverTimeMenu" v-model="startOverTime" format="24hr" :max="endOverTime" full-width @click:minute="$refs.startOverMenu.save(startOverTime)"/>
              </v-menu>
            </v-row>
            <v-row>
              <v-menu ref="endOverMenu" v-model="endOverTimeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="endOverTime"
              transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="endOverTime" label="残業終了時間" dense outlined readonly v-on="on"/>
                </template>
                <v-time-picker v-if="endOverTimeMenu" v-model="endOverTime" format="24hr" :min="startOverTime" full-width @click:minute="$refs.endOverMenu.save(endOverTime)"/>
              </v-menu>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field label="休憩(時間)" v-model="breakHourTime" :rules="breakHourTimeRules" suffix="時間" dense outlined/>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field label="休憩(分)" v-model="breakMinuteTime" :rules="breakMinuteTimeRules" suffix="分" dense outlined/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed color="grey lighten-1" @click.stop="overTimeDialogDrawer = false">キャンセル</v-btn>
            <v-btn depressed color="success" @click.stop="overTimeDialogHandler()" :disabled="!breakTimeValid">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業日報確認ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="confirmInputDialogDrawer" persistent max-width="700px">
      <v-card>
        <v-card-title class="headline">作業日報確認</v-card-title>
        <v-card-text>
          <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ inputData.tabName }}</v-toolbar-title></v-toolbar>
          <v-row v-if="inputData.constructionType != null">
            <v-col cols="4"><header>工種</header></v-col>
            <v-col cols="8"><header>{{ inputData.constructionType.name }}</header></v-col>
          </v-row>
          <v-divider v-if="(inputData.constructionType != null)"/>
          <v-row v-if="inputData.workItem != null && !inputData.workArea">
            <v-col cols="4"><header>作業項目</header></v-col>
            <v-col cols="8"><header>{{ inputData.workItem.name }}</header></v-col>
          </v-row>
          <v-divider v-if="(inputData.workItem != null) && !inputData.workArea"/>
          <v-row v-if="(inputData.startWorkerTime != null && inputData.endWorkerTime != null) && !inputData.workArea">
            <v-col cols="4"><header>作業時間</header></v-col>
            <v-col cols="8"><header>{{ inputData.startWorkerTime }}〜{{ inputData.endWorkerTime }} (休憩時間：{{ inputData.workerBreakHourTime }}時間{{ inputData.workerBreakMinuteTime }}分)</header></v-col>
          </v-row>
          <v-divider v-if="(inputData.startWorkerTime != null && inputData.endWorkerTime != null) && !inputData.workArea"/>
          <v-row v-if="(inputData.startOverTime != null && inputData.endOverTime != null) && !inputData.workArea">
            <v-col cols="4"><header>残業時間</header></v-col>
            <v-col cols="8"><header>{{ inputData.startOverTime }}〜{{ inputData.endOverTime }} (休憩時間：{{ inputData.overBreakHourTime }}時間{{ inputData.overBreakMinuteTime }}分)</header></v-col>
          </v-row>
          <v-divider v-if="(inputData.startOverTime != null && inputData.endOverTime != null) && !inputData.workArea"/>
          <v-row>
            <v-col cols="4"><header>作業内容</header></v-col>
            <v-col cols="8"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ inputData.workerContent }}</header></v-col>
          </v-row>
          <v-divider/>
          <v-row v-if="inputData.businessTrip != ''">
            <v-col cols="4"><header>出張先</header></v-col>
            <v-col cols="8"><header>{{ inputData.businessTrip }}</header></v-col>
          </v-row>
          <v-divider v-if="inputData.businessTrip != ''"/>
          <v-row v-if="inputData.businessTrip != ''">
            <v-col cols="4"><header>宿泊</header></v-col>
            <v-col cols="8"><header>{{ inputData.stay ? '宿泊あり' : '宿泊なし' }}</header></v-col>
          </v-row>
          <v-divider v-if="inputData.businessTrip != ''"/>
          <v-row v-if="inputData.move != moveWay.nothing.id">
            <v-col cols="4"><header>移動方法</header></v-col>
            <v-col cols="8">
              <header>
                <span v-if="inputData.move == moveWay.airplane.id">{{ moveWay.airplane.name }}</span>
                <span v-else-if="inputData.move == moveWay.jr.id">{{ moveWay.jr.name }}</span>
                <span v-else-if="inputData.move == moveWay.car.id">{{ moveWay.car.name }}</span>
              </header>
            </v-col>
          </v-row>
          <v-divider v-if="inputData.move != moveWay.nothing.id"/>
          <v-row v-if="inputData.move == moveWay.car.id">
            <v-col cols="4"><header>高速道路(ETC)</header></v-col>
            <v-col cols="8"><header>{{ inputData.etc ? '使用あり' : '使用なし' }}</header></v-col>
          </v-row>
          <v-divider v-if="inputData.move == moveWay.car.id"/>
          <v-row v-if="inputData.remark">
            <v-col cols="4"><header>備考</header></v-col>
            <v-col cols="8"><header>{{ inputData.remark }}</header></v-col>
          </v-row>
          <v-divider/>
          <v-row>
            <v-col cols="12">
            <div v-for="(data, name) in inputData.expenseTableData" :key="name">
              <v-data-table v-if="data.length > 0" :headers="comformHeaders" :items="data" :items-per-page="itemPerPage" hide-default-footer>
                <template slot="top">
                  <v-toolbar color="grey" dark flat dense>
                    <v-toolbar-title>{{ name }}</v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
              <v-divider v-if="data.length > 0"/>
            </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" @click="cancelWorkReportConfirm()">キャンセル</v-btn>
          <v-btn color="success" @click.prevent="saveWorkReport()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <!-- 作業日報確認ダイアログ（申請） -->
  <v-row justify="center">
    <v-dialog v-model="confirmationDialogDrawer" persistent max-width="700px">
      <v-card>
        <v-card-title class="headline">作業日報確認</v-card-title>
        <v-card-text>
          <v-tabs v-model="confirmSelectTab" background-color="accent" dark next-icon="mdi-arrow-right-bold-box-outline" prev-icon="mdi-arrow-left-bold-box-outline" show-arrows>
            <v-tab v-for="index in tabLength" :key="index" :href="'#tab-' + index">
              {{ tabDataList['tab-' + index].tabName }}
            </v-tab>
            <v-tabs-slider color="red"/>
          </v-tabs>
          <v-tabs-items v-model="confirmSelectTab">
            <v-tab-item v-for="index in tabLength" :key="index" :value="'tab-' + index">
              <v-row v-if="tabDataList['tab-' + index].constructionType != null">
                <v-col cols="4"><header>工種</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].constructionType.name }}</header></v-col>
              </v-row>
              <v-divider v-if="(tabDataList['tab-' + index].constructionType != null)"/>
              <v-row v-if="tabDataList['tab-' + index].workItem != null && !tabDataList['tab-' + index].workArea">
                <v-col cols="4"><header>作業項目</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].workItem.name }}</header></v-col>
              </v-row>
              <v-divider v-if="(tabDataList['tab-' + index].workItem != null) && !tabDataList['tab-' + index].workArea"/>
              <v-row v-if="(tabDataList['tab-' + index].startWorkerTime != null && tabDataList['tab-' + index].endWorkerTime != null) && !tabDataList['tab-' + index].workArea">
                <v-col cols="4"><header>作業時間</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].startWorkerTime }}〜{{ tabDataList['tab-' + index].endWorkerTime }} (休憩時間：{{ tabDataList['tab-' + index].workerBreakHourTime }}時間{{ tabDataList['tab-' + index].workerBreakMinuteTime }}分)</header></v-col>
              </v-row>
              <v-divider v-if="(tabDataList['tab-' + index].startWorkerTime != null && tabDataList['tab-' + index].endWorkerTime != null) && !tabDataList['tab-' + index].workArea"/>
              <v-row v-if="(tabDataList['tab-' + index].startOverTime != null && tabDataList['tab-' + index].endOverTime != null) && !tabDataList['tab-' + index].workArea">
                <v-col cols="4"><header>残業時間</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].startOverTime }}〜{{ tabDataList['tab-' + index].endOverTime }} (休憩時間：{{ tabDataList['tab-' + index].overBreakHourTime }}時間{{ tabDataList['tab-' + index].overBreakMinuteTime }}分)</header></v-col>
              </v-row>
              <v-divider v-if="(tabDataList['tab-' + index].startOverTime != null && tabDataList['tab-' + index].endOverTime != null) && !tabDataList['tab-' + index].workArea"/>
              <v-row>
                <v-col cols="4"><header>作業内容</header></v-col>
                <v-col cols="8"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ tabDataList['tab-' + index].workerContent }}</header></v-col>
              </v-row>
              <v-divider/>
              <v-row v-if="tabDataList['tab-' + index].businessTrip != ''">
                <v-col cols="4"><header>出張先</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].businessTrip }}</header></v-col>
              </v-row>
              <v-divider v-if="tabDataList['tab-' + index].businessTrip != ''"/>
              <v-row v-if="tabDataList['tab-' + index].businessTrip != ''">
                <v-col cols="4"><header>宿泊</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].stay ? '宿泊あり' : '宿泊なし' }}</header></v-col>
              </v-row>
              <v-divider v-if="tabDataList['tab-' + index].businessTrip != ''"/>
              <v-row v-if="tabDataList['tab-' + index].move != moveWay.nothing.id">
                <v-col cols="4"><header>移動方法</header></v-col>
                <v-col cols="8">
                  <header>
                    <span v-if="tabDataList['tab-' + index].move == moveWay.airplane.id">{{ moveWay.airplane.name }}</span>
                    <span v-else-if="tabDataList['tab-' + index].move == moveWay.jr.id">{{ moveWay.jr.name }}</span>
                    <span v-else-if="tabDataList['tab-' + index].move == moveWay.car.id">{{ moveWay.car.name }}</span>
                  </header>
                </v-col>
              </v-row>
              <v-divider v-if="tabDataList['tab-' + index].move != moveWay.nothing.id"/>
              <v-row v-if="tabDataList['tab-' + index].move == moveWay.car.id">
                <v-col cols="4"><header>高速道路(ETC)</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].etc ? '使用あり' : '使用なし' }}</header></v-col>
              </v-row>
              <v-divider v-if="tabDataList['tab-' + index].move == moveWay.car.id"/>
              <v-row>
                <v-col cols="4"><header>備考</header></v-col>
                <v-col cols="8"><header>{{ tabDataList['tab-' + index].remark }}</header></v-col>
              </v-row>
              <v-divider/>
              <v-row>
                <v-col cols="12">
                <div v-for="(data, name) in tabDataList['tab-' + index].expenseTableData" :key="name">
                  <v-data-table v-if="data.length > 0" :headers="comformHeaders" :items="data" :items-per-page="itemPerPage" hide-default-footer>
                    <template slot="top">
                      <v-toolbar color="grey" dark flat dense>
                        <v-toolbar-title>{{ name }}</v-toolbar-title>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                  <v-divider v-if="data.length > 0"/>
                </div>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" @click.stop="confirmationDialogDrawer = false">キャンセル</v-btn>
          <v-btn color="success" @click.prevent="updateWorkerDailyReportStatus(1)">申請</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import Rule from "@/validation/rules";
import WorkerDailyReportSubApi from "@/api/worker-daily-report-sub-api";
import ConstructionDateApi from "@/api/construction-date-api";
import BudgetLatestApi from "@/api/budget-latest-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable2";

export default {
  name: "WorkerDailyReportEdit",
  components: {
    CustomDataTable,
  },
  props: ["user"],
  data: () => ({
    loading: false,
    // 画面引数
    prmUserId: null,
    prmWorkerDate: "",
    prmConstructionKey: null,
    // 戻り先
    returnView: {},
    // ------------------------
    // 一覧データ表示用リスト
    // ------------------------
    reportHeaders: [
      { text: "No", value: "no" },
      { text: "工番", value: "construction_number", bottomText: "工事名", bottomValue: "construction_name" },
      { text: "工種", value: "construction_type_name", bottomText: "作業項目", bottomValue: "work_item_name" },
      { text: "開始時間", value: "start_work_time", bottomText: "終了時間", bottomValue: "end_work_time" },
      { text: "休憩時間", value: "worker_break_time" },
      { text: "残業開始", value: "start_over_time", bottomText: "残業終了", bottomValue: "end_over_time" },
      { text: "残業時休憩時間", value: "worker_over_break_time" },
      { text: "作業内容", value: "action_worker_content" },
      { text: "アクション", value: "action" },
      { text: "", value: "action_sub" },
    ],
    reportItems: [],
    employeeAttribute: null,

    // ------------------------
    // 共通
    // ------------------------
    // 作業日
    constructionDate: "",
    constructionDateSlash: "",
    constructionDateValid: true,
    // 工番
    constructionNumber: null,
    // 工番リスト
    constructionNumberList: [],
    // 作業報告データリスト
    tabDataList: {},
    // 作業報告IDリスト
    tabIdList: {},
    // 作業項目可否
    workAreaDivision: false,
    // 一覧データリスト追加用
    tabData: {
      tabName: null,
      constructionId: null,
      constructionNumber: null,
      constructionName: null,
      siteName: null,
      constructionTypeList: null,
      constructionType: null,
      workArea: false,
      workItemList: null,
      workItem: null,
      startWorkerTime: null,
      endWorkerTime: null,
      workerBreakHourTime: 0,
      workerBreakMinuteTime: 0,
      startOverTime: null,
      endOverTime: null,
      overBreakHourTime: 0,
      overBreakMinuteTime: 0,
      workerContent: "",
      businessTrip: "",
      stay: false,
      move: 0,
      etc: false,
      remark: null,
      priceUpdated: "",
      expenseTableDataList: null,
      expenseTableData: null,
      expenseSelectBoxList: null,
      expenseSelectBox: null,
      workerTime: null,
      overTime: null
    },
    // 作業報告入力ダイアログ用バッファ
    inputData: {
      tabName: null,
      constructionId: null,
      constructionNumber: null,
      constructionName: null,
      siteName: null,
      constructionTypeList: null,
      constructionType: null,
      workArea: false,
      workItemList: null,
      workItem: null,
      startWorkerTime: null,
      endWorkerTime: null,
      workerBreakHourTime: 0,
      workerBreakMinuteTime: 0,
      startOverTime: null,
      endOverTime: null,
      overBreakHourTime: 0,
      overBreakMinuteTime: 0,
      workerContent: "",
      businessTrip: "",
      stay: false,
      move: 0,
      etc: false,
      remark: null,
      priceUpdated: "",
      expenseTableDataList: null,
      expenseTableData: null,
      expenseSelectBoxList: null,
      expenseSelectBox: null,
      workerTime: null,
      overTime: null
    },

    // ------------------------
    // タブ
    // ------------------------
    tabLength: 0,
    selectTab: null,
    selectId: 0,

    // ------------------------
    // 作業報告
    // ------------------------
    // 作業項目
    constructionTypeRules: Rule.constructionTypeRules,
    workItemList: [],
    workItemRules: Rule.workItemRules,
    // 休憩時間
    breakTimeValid: false,
    breakHourTime: null,
    breakMinuteTime: null,
    breakHourTimeRules: Rule.breakHourTimeRules,
    breakMinuteTimeRules: Rule.breakMinuteTimeRules,
    // 作業開始時間
    startWorkerTime: null,
    startWorkerTimeMenu: false,
    workerTimeStartRules: Rule.workerTimeStartRules,
    // 作業終了時間
    endWorkerTime: null,
    endWorkerTimeMenu: false,
    workerTimeEndRules: Rule.workerTimeEndRules,
    // 残業開始時間
    startOverTime: null,
    startOverTimeMenu: false,
    // 残業終了時間
    endOverTime: null,
    endOverTimeMenu: false,
    // 移動方法
    moveWay: {
      nothing: {name: "なし", id: 0},
      airplane: {name: "飛行機", id: 1},
      jr: {name: "JR", id: 2},
      car: {name: "社用車/自家用車", id: 3}
    },
    // 作業内容
    workerContentRules: Rule.workerContentRules,

    // ------------------------
    // 経費区分
    // ------------------------
    expenseDivisionData: [],
    expenseDivision: false,
    expenseDataTable: null,
    expenseSelectBox: null,

    // ------------------------
    // 工番作成ダイアログ
    // ------------------------
    constructionNumberCreateDialogDrawer: false,
    constructionNumberCreateDialogValid: false,
    department: null,
    departmentItems: [],
    constructionNumberTagRules: Rule.constructionNumberTagRules,
    departmentRules: Rule.departmentRules,

    // ------------------------
    // 作業報告編集ダイアログ
    // ------------------------
    workReportInputDialogDrawer: false,
    workReportInputDialogValid: true,

    // ------------------------
    // 作業報告削除ダイアログ
    // ------------------------
    workReportDeleteDialogDrawer: false,

    // ------------------------
    // 作業内容参照ダイアログ
    // ------------------------
    workerContentReferenceDialogDrawer: false,

    // ------------------------
    // 作業時間入力ダイアログ
    // ------------------------
    workerTimeDialogDrawer: false,

    // ------------------------
    // 残業時間入力ダイアログ
    // ------------------------
    overTimeDialogDrawer: false,

    // ------------------------
    // 作業報告確認ダイアログ
    // ------------------------
    confirmInputDialogDrawer: false,

    // ------------------------
    // 作業報告確認ダイアログ（申請）
    // ------------------------
    confirmationDialogDrawer: false,
    confirmSelectTab: null,
    comformHeaders: [
      { text: "費目名", value: "expense", sortable: false },
      { text: "規格等", value: "standard", sortable: false },
      { text: "実績 / 予算", value: "displayAchievement", sortable: false },
      { text: "単位", value: "displayUnit", sortable: false },
      { text: "取引先", value: "supplierName", sortable: false }
    ],
    itemPerPage: 300
  }),
  created() {
    this.initialize();
  },
  // updated() {
  //   // ダイアログのスクロール位置をTOPに戻す
  //   const elements = document.getElementsByClassName('v-dialog--active');
  //   if (!elements || !elements.length) {
  //     return;
  //   }
  //   elements[0].scrollTop = 0;
  // },
  methods: {
    // ------------------------
    // 初期化処理
    // ------------------------
    initialize() {
      this.isLoading();
      // 画面引数をセット
      this.prmUserId = this.$route.params.user_id;
      this.prmWorkerDate = this.$route.params.worker_date;
      if (this.$route.params.construction_key) {
        this.prmConstructionKey = this.$route.params.construction_key;
      }
      // 遷移元画面に応じたパンくずリストの設定
      let breadcrumbs = [];
      if (!this.prmConstructionKey) {
        // 作業日報一覧画面から遷移
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
          { text: "作業日報編集", disabled: true }
        ];
        this.returnView = { name: "WorkerDailyReport" };
      } else {
        // 工事日報編集画面から遷移
        const toView = {
          name: "ConstructionDailyReportEdit",
          params: this.prmConstructionKey
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "工事日報一覧", disabled: false, href: "/report/daily/construction" },
          { text: "工事日報再集計", disabled: false, href: null, to: toView },
          { text: "作業日報編集", disabled: true }
        ];
        this.returnView = toView;
      }
      if (breadcrumbs) {
        this.$route.meta.breadcrumbs = breadcrumbs;
        this.$emit('updatebc');
      }
      //
      this.constructionDate = this.parseDate(this.prmWorkerDate);
      this.constructionDateSlash = this.prmWorkerDate;
      this.constructionDateValid = (this.constructionDate === undefined) || (this.constructionDate === null);
      this.workerDailyReportSubApi = new WorkerDailyReportSubApi();
      this.budgetLatestApi = new BudgetLatestApi();
      this.constructionDateApi = new ConstructionDateApi();
      // 作業日報と関連リストを取得
      const promise = this.workerDailyReportSubApi.info(this.constructionDate, this.prmUserId);
      promise.then((response) => {
        // 社員属性
        this.employeeAttribute = response.data.body.employee_attribute;
        // 部署リスト
        for (let item of response.data.body.department_list) {
          let department_name = item.name;
          if (item.section) {
              department_name = item.name + " - " + item.section;
          }
          this.departmentItems.push({
              name: department_name,
              value: item.id
          });
        }
        // 集計費目リスト
        for (let agregateName in response.data.body.aggregate_list) {
          const agregate = response.data.body.aggregate_list[agregateName];
          this.expenseDivisionData[agregateName] = agregate;
        }
        // 作業日報情報
        for (let item of response.data.body.worker_daily_report_info) {
          this.tabLength++;
          this.selectTab = 'tab-' + this.tabLength;
          this.tabDataList[this.selectTab] = item.report;
          this.tabIdList[this.selectTab] = { id: item.id };
        }
        if (this.tabLength > 0) {
          this.selectTab = 'tab-1';
          this.tabChange();
        }
        // 画面用バッファへ反映
        this.refreshDisplay();
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push(this.returnView);
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },

    // 表示用バッファへ反映
    refreshDisplay() {
      this.reportItems = [];
      let idx = 0;
      for (let index in this.tabDataList) {
        idx++;
        let item = this.tabDataList[index];
        let constructionType = null;
        if (item.constructionType != null) {
          constructionType = item.constructionType;
        }
        let itemId = this.tabIdList[index];
        this.reportItems.push({
          id: itemId.id,
          tabIndex: index,
          no: idx,
          construction_number: item.constructionNumber,
          construction_name: item.constructionName,
          construction_type_name: constructionType.name,
          work_item_name: item.workItem == null ? null : item.workItem.name,
          start_work_time: item.startWorkerTime,
          end_work_time: item.endWorkerTime,
          worker_break_time: this.formatDispTime(item.workerBreakHourTime, item.workerBreakMinuteTime),
          start_over_time: item.startOverTime,
          end_over_time: item.endOverTime,
          worker_over_break_time: this.formatDispTime(item.overBreakHourTime, item.overBreakMinuteTime),
          worker_content: item.workerContent
        });
      }
    },

    // タブ変更処理
    tabChange() {
      this.expenseDivision = false;
      if (this.tabLength > 0) {
        if (this.inputData.constructionType != null) {
          const constructionTypeIndex = this.inputData.constructionType.value;
          this.inputData.expenseTableData = this.inputData.expenseTableDataList[constructionTypeIndex];
          for (let data of this.expenseDivisionData) {
            if (!(data.name in this.inputData.expenseTableData)) {
              this.inputData.expenseTableData[data.name] = [];
            }
          }
          this.expenseDataTable = this.inputData.expenseTableData;
          this.inputData.expenseSelectBox = this.inputData.expenseSelectBoxList[constructionTypeIndex];
          this.expenseSelectBox = this.inputData.expenseSelectBox;
          this.expenseDivision = true;
        }
        this.workAreaDivision = this.inputData.workArea;
      }
    },

    // ---------------------------------------------
    // -- メインコンテンツ
    // ---------------------------------------------
    // ---------------------------------------------
    // イベント処理「作業報告作成」ボタン押下
    // ---------------------------------------------
    showConstructionNumberCreateDialog() {
      // 工番作成ダイアログを表示する
      this.selectId = 0;
      this.constructionNumberCreateDialogDrawer = true;
    },
    // ---------------------------------------------
    // イベント処理「作業報告編集」ボタン押下
    // ---------------------------------------------
    showWorkReportInputDialog(id, tabIndex) {
      // 作業報告編集ダイアログを表示する
      this.selectId = id;
      this.selectTab = tabIndex;
      this.tabChange();
      this.inputData = Object.assign({}, this.tabDataList[tabIndex]);
      this.workAreaChange();
      this.workReportInputDialogDrawer = true;
    },
    // ---------------------------------------------
    // イベント処理「作業報告削除」ボタン押下
    // ---------------------------------------------
    showWorkReportDeleteDialog(id, tabIndex) {
      // 作業報告削除ダイアログを表示する
      this.selectId = id;
      this.selectTab = tabIndex;
      this.workReportDeleteDialogDrawer = true;
    },
    // ---------------------------------------------
    // イベント処理「作業内容参照」ボタン押下
    // ---------------------------------------------
    showWorkerContentReferenceDialog(tabIndex) {
      this.selectTab = tabIndex;
      this.workerContentReferenceDialogDrawer = true;
    },
    // ---------------------------------------------
    // イベント処理「確認」ボタン押下
    // ---------------------------------------------
    showConfirmationDialog() {
      this.selectTab = 'tab-1';
      this.tabChange();
      this.confirmSelectTab = this.selectTab;
      this.confirmationDialogDrawer = true;
    },

    // ---------------------------------------------
    // -- 工番作成ダイアログ
    // ---------------------------------------------
    // ---------------------------------------------
    // -- 工番作成ダイアログ：イベント処理「部署」リスト選択変更
    // ---------------------------------------------
    changeDepartment(item) {
      // 選択された部署に属する工番リストを構築する
      this.isLoading();
      const promise = this.constructionDateApi.info(this.constructionDate, item.value);
      promise.then((response) => {
        this.constructionNumberList = [];
        for (let item of response.data.body.construction_date_list) {
          this.constructionNumberList.push({
            id: item.id,
            text: item.construction_number + " : " + item.construction_name,
            number: item.construction_number,
            name: item.construction_name,
            place: item.place
          });
        }
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // ---------------------------------------------
    // -- 工番作成ダイアログ：イベント処理「キャンセル」ボタン押下
    // ---------------------------------------------
    hideConstructionNumberCreateDialog() {
      // 工番作成ダイアログを非表示する
      this.constructionNumberCreateDialogDrawer = false;
      this.department = null,
      this.$refs.construction_number_create_form.resetValidation();
    },
    // ---------------------------------------------
    // -- 工番作成ダイアログ：イベント処理「作成」ボタン押下
    // ---------------------------------------------
    createConstructionNumberCreateDialog() {
      this.isLoading();
      // 実行予算からデータ取得して、経費情報を初期構築する
      let tmpList = [];
      let tmpWorkItemList = [];
      let tmpDataTable = {};
      let tmpSelectBox = {};
      const promise = this.budgetLatestApi.info(this.constructionNumber.id);
      promise.then((response) => {
        let index = 1;
        for (let budget of response.data.body.budget_latest_info.tree_data.row) {
          this.reduceExpense(String(index), budget, tmpList, tmpWorkItemList, tmpDataTable, tmpSelectBox);
          index++;
        }
        // 入力バッファを初期化セット
        this.inputData = Object.assign({}, this.tabData);
        this.inputData.constructionTypeList = tmpList;
        this.inputData.workItemList = [];
        this.inputData.workItem = null;
        this.inputData.workArea = false;
        this.inputData.expenseTableDataList = tmpDataTable;
        this.inputData.expenseTableData = [];
        this.inputData.expenseSelectBoxList = tmpSelectBox;
        this.inputData.expenseSelectBox = [];
        this.inputData.tabName = this.constructionNumber.number;
        this.inputData.constructionID = this.constructionNumber.id;
        this.inputData.constructionNumber = this.constructionNumber.number;
        this.inputData.constructionName = this.constructionNumber.name;
        this.inputData.siteName = this.constructionNumber.place;
        this.inputData.workerBreakHourTime = this.employeeAttribute.worker_break_hour_time;
        this.inputData.workerBreakMinuteTime = this.employeeAttribute.worker_break_minute_time;
        // クリア
        this.constructionNumber = null;
        this.expenseDivision = false;
        this.expenseDataTable = null;
        this.workAreaDivision = false;
        this.workItemList = tmpWorkItemList;
        // 工番作成ダイアログを非表示する
        this.constructionNumberCreateDialogDrawer = false;
        this.department = null;
        this.$refs.construction_number_create_form.resetValidation();
        // 作業報告編集ダイアログを表示する
        if (this.$refs.worker_report_input_form) {
          this.$refs.worker_report_input_form.resetValidation();
        }
        this.workReportInputDialogDrawer = true;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.constructionNumberCreateDialogDrawer = false;
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // ---------------------------------------------
    // 経費情報を構築
    // ---------------------------------------------
    reduceExpense(index, object, list, workItemList, dataTable, selectBox) {
      if (object.children.length > 0) {
        let childIndex = 1;
        for (let child of object.children) {
          let node = index + "-" + childIndex;
          this.reduceExpense(node, child, list, workItemList, dataTable, selectBox);
          childIndex++;
        }
      }
      if (object.data.items.length > 0) {
        list.push({name: object.text, value: index});
        let tempDataTable = {};
        let tempSelectBox = {};
        object.data.items.map(function(item){
          if (item.aggregate != null) {
            let expense = item.aggregateName;
            if (item.aggregate.flg) {
              workItemList.push({name: item.expense, value: item, construction_type: index});
            } else {
              if (typeof tempDataTable[expense]=="undefined") tempDataTable[expense] = [];
              if (typeof tempSelectBox[expense]=="undefined") tempSelectBox[expense] = [];
              tempSelectBox[expense].push(item);
            }
          }
        });
        dataTable[index] = tempDataTable;
        selectBox[index] = tempSelectBox;
      }
    },

    // ---------------------------------------------
    // -- 作業報告編集ダイアログ
    // ---------------------------------------------
    // ---------------------------------------------
    // -- 作業報告編集ダイアログ：イベント処理「工種」リスト選択変更
    // ---------------------------------------------
    changeConstructionType() {
      const constructionTypeIndex = this.inputData.constructionType.value;
      this.inputData.workItemList = this.workItemList.filter(item => item.construction_type == constructionTypeIndex);
      this.inputData.expenseTableData = this.inputData.expenseTableDataList[constructionTypeIndex];
      for (let data of this.expenseDivisionData) {
        if (!(data.name in this.inputData.expenseTableData)) {
          this.inputData.expenseTableData[data.name] = [];
        }
      }
      this.expenseDataTable = this.inputData.expenseTableData;
      this.inputData.expenseSelectBox = this.inputData.expenseSelectBoxList[constructionTypeIndex];
      this.expenseSelectBox = this.inputData.expenseSelectBox;
      this.expenseDivision = (this.inputData.constructionType != null);
    },
    // ---------------------------------------------
    // -- 作業報告編集ダイアログ：イベント処理「作業項目なし」チェックボックス状態変更
    // ---------------------------------------------
    workAreaChange() {
      this.workAreaDivision = this.inputData.workArea;
    },
    // ---------------------------------------------
    // -- 作業報告編集ダイアログ：イベント処理「キャンセル」ボタン押下
    // ---------------------------------------------
    cancelWorkReport() {
      this.workReportInputDialogDrawer = false;
      if (this.$refs.worker_report_input_form) {
        this.$refs.worker_report_input_form.resetValidation();
      }
    },
    cancelWorkReportConfirm() {
      this.confirmInputDialogDrawer =false;
    },
    // ---------------------------------------------
    // -- 作業報告編集ダイアログ：イベント処理「作成」ボタン押下
    // ---------------------------------------------
    saveWorkReport() {
      this.isLoading();
      const id = this.selectId;
      const status = 0;
      if (this.inputData.workArea) {
        this.inputData.workItem = null;
        this.inputData.startWorkerTime = null;
        this.inputData.endWorkerTime = null;
        this.inputData.startOverTime = null;
        this.inputData.endOverTime = null;
      }
      const params = {
          user_id: this.prmUserId,
          construction_id: this.inputData.constructionID,
          status: status,
          worker_date: this.constructionDate,
          report: JSON.stringify(this.inputData),
          holiday_flg: false
      };
      if (id > 0) {
        // 作業日報を修正
        const promise = this.workerDailyReportSubApi.update(id, { params: params });
        promise.then((response) => {
          this.tabDataList[this.selectTab] = Object.assign({}, this.inputData);
          // 作業報告編集ダイアログを非表示
          this.confirmInputDialogDrawer = false;
          this.workReportInputDialogDrawer = false;
          if (this.$refs.worker_report_input_form) {
            this.$refs.worker_report_input_form.resetValidation();
          }
          // 表示用バッファへ反映
          this.refreshDisplay();
          this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      } else {
        // 作業日報を新規登録
        const promise = this.workerDailyReportSubApi.store({ params: params });
        promise.then((response) => {
          const rec_id = response.data.body.rec_id;
          this.tabLength++;
          this.selectTab = 'tab-' + this.tabLength;
          this.tabDataList[this.selectTab] = Object.assign({}, this.inputData);
          this.tabIdList[this.selectTab] = Object.assign({}, { id: rec_id });
          // 作業報告編集ダイアログを非表示
          this.confirmInputDialogDrawer = false;
          this.workReportInputDialogDrawer = false;
          if (this.$refs.worker_report_input_form) {
            this.$refs.worker_report_input_form.resetValidation();
          }
          // 表示用バッファへ反映
          this.refreshDisplay();
          this.$emit('success', response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    },

    // ---------------------------------------------
    // -- 作業報告削除ダイアログ
    // ---------------------------------------------
    // ---------------------------------------------
    // イベント処理：「削除」ボタン押下
    // ---------------------------------------------
    deleteWorkReport() {
      // 作業日報を削除
      this.isLoading();
      const promise = this.workerDailyReportSubApi.delete(this.selectId);
      promise.then((response) => {
        this.tabLength--;
        delete this.tabDataList[this.selectTab];
        // 再構築（tabIndexを採番）
        let tmp = {};
        let index = 1;
        for (let key in this.tabDataList) {
          tmp['tab-' + index] = Object.assign({}, this.tabDataList[key]);
          index++;
        }
        //
        this.selectTab = 'tab-1';
        this.tabDataList = tmp;
        this.tabChange();
        // 表示用バッファへ反映
        this.refreshDisplay();
          // 作業報告削除ダイアログを非表示
        this.workReportDeleteDialogDrawer = false;
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },

    // ---------------------------------------------
    // -- 作業時間入力ダイアログ
    // ---------------------------------------------
    workerTimeInput() {
      this.startWorkerTime = this.inputData.startWorkerTime;
      this.endWorkerTime = this.inputData.endWorkerTime;
      this.breakHourTime = this.inputData.workerBreakHourTime;
      this.breakMinuteTime = this.inputData.workerBreakMinuteTime;
      this.workerTimeDialogDrawer = true;
    },
    workerTimeDialogHandler() {
      this.inputData.startWorkerTime = this.startWorkerTime;
      this.inputData.endWorkerTime = this.endWorkerTime;
      this.inputData.workerBreakHourTime = this.breakHourTime;
      this.inputData.workerBreakMinuteTime = this.breakMinuteTime;
      this.inputData.workerTime = this.calcWorkTime(this.startWorkerTime, this.endWorkerTime, this.breakHourTime, this.breakMinuteTime);
      this.workerTimeDialogDrawer = false;
      this.startWorkerTime = null;
      this.endWorkerTime = null;
    },

    // ---------------------------------------------
    // -- 残業時間入力ダイアログ
    // ---------------------------------------------
    overTimeDialogInput() {
      this.startOverTime = this.inputData.startOverTime;
      this.endOverTime = this.inputData.endOverTime;
      this.breakHourTime = this.inputData.overBreakHourTime;
      this.breakMinuteTime = this.inputData.overBreakMinuteTime;
      this.overTimeDialogDrawer = true;
    },
    overTimeDialogHandler() {
      this.inputData.startOverTime = this.startOverTime;
      this.inputData.endOverTime = this.endOverTime;
      this.inputData.overBreakHourTime = this.breakHourTime;
      this.inputData.overBreakMinuteTime = this.breakMinuteTime;
      this.inputData.overTime = this.calcWorkTime(this.startOverTime, this.endOverTime, this.breakHourTime, this.breakMinuteTime);
      this.overTimeDialogDrawer = false;
      this.startOverTime = null;
      this.endOverTime = null;
    },

    // ---------------------------------------------
    // -- 作業報告確認ダイアログ
    // ---------------------------------------------
    // ---------------------------------------------
    // イベント処理：「申請」ボタン押下
    // ---------------------------------------------
    updateWorkerDailyReportStatus(status) {
      // 作業日報のステータスを更新する（API送信によるDB更新）
      this.isLoading();
      const promise = this.workerDailyReportSubApi.updateStatus(this.constructionDate, this.prmUserId, status);
      promise.then((response) => {
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.$router.push(this.returnView);
      });
    },

    // ---------------------------------------------
    // -- その他処理
    // ---------------------------------------------
    // ローディング表示・非表示
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    // 日付フォーマット
    parseDate(date) {
      if (!date) return null;
      const [year,month, day] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    // 時刻計算
    calcWorkTime(startTime, endTime, breakHourTime, breakMinuteTime) {
      // 開始時刻
      var startTimeSplit = [];
      var startTimeHour = 0;
      var startTimeMinute = 0;
      if (startTime != null && startTime != undefined) {
        startTimeSplit = startTime.split(':');
      }
      if (startTimeSplit.length > 0) {
        startTimeHour = parseInt(startTimeSplit[0]);
        if (0 < parseInt(startTimeSplit[1])) {
          startTimeHour = startTimeHour + 1;
          startTimeMinute = 60 - parseInt(startTimeSplit[1]);
        }
      }
      // 終了時刻
      var endTimeSplit = [];
      var endTimeHour = 0;
      var endTimeMinute = 0;
      if (endTime != null && endTime != undefined) {
        endTimeSplit = endTime.split(':');
      }
      if (endTimeSplit.length > 0) {
        endTimeHour = parseInt(endTimeSplit[0]);
        endTimeMinute = parseInt(endTimeSplit[1]);
      }
      // 計算
      var hour = 0;
      if (startTimeHour < endTimeHour) {
        hour = endTimeHour - startTimeHour
        if (breakHourTime != null) {
          hour = hour - breakHourTime;
        }
      }
      var minute = 0;
      var temp = (startTimeMinute + endTimeMinute);
      if (breakMinuteTime != null) {
        if (temp < breakMinuteTime) {
          hour = hour - 1;
          temp = 60 - (breakMinuteTime - temp);
        } else {
          temp = temp - breakMinuteTime;
        }
      }
      if (60 < temp) {
        hour = hour + 1;
        minute = 60 - temp;
      } else {
        minute = temp;
      }
      return { hour: hour, minute: minute };
    },
    // -----------------------------------------------------
    // 表示時間フォーマット
    // -----------------------------------------------------
    formatDispTime(hour, minute) {
      let retStr = '';
      if (hour > 0) {
        retStr = hour + '時間';
      }
      if (minute > 0) {
        retStr += minute + '分';
      }
      if (!retStr) {
        retStr = '0分';
      }
      return retStr;
    }
  }
}
</script>
